/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
export type collaboratorFragment = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly createAsAdmin: boolean | null, readonly lastLoginAt: any | null };

export const collaboratorFragment = gql`
    fragment collaboratorFragment on CreditApplicationPerson {
  id
  email
  firstName
  lastName
  createAsAdmin
  lastLoginAt
}
    `;